module.exports = __webpack_public_path__ + "img/wishlist-2.60ee4b7.png";